import { Img } from "../../components";
import React from "react";

export default function ImageRowSection() {
  return (
    <>
      {/* image row section */}
      <div className="w-full overflow-hidden">
        <Img
          src="images/img_frame_427319669.webp"
          alt="Image"
          className="w-full h-auto object-contain md:h-auto sm:h-[400px]"
        />
      </div>
    </>
  );
}
